// extracted by mini-css-extract-plugin
module.exports = {"draggableElement":"ProductCarousel_draggableElement__tg5p3","title":"ProductCarousel_title__AtgES","root":"ProductCarousel_root__YzCGv"};